import { MODULES } from "#constants/modules"
import PERMISOS from "#constants/perfiles"
import { ContextsCompetenceProvider } from "./contexts/ContextsCompetence"
import Category from "./pages/Category"
import Competencia from "./pages/Competencia"
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
export const URLS = [
	{
		module: MODULES.PERFIL_PUESTO,
		path: "competencia",
			element: (
				<ContextsCompetenceProvider>
					<Competencia />
				</ContextsCompetenceProvider>
			),
			title: "Competencias",
			icon: LocalLibraryIcon  ,
			permissions: [PERMISOS.RH],
			textDivider: "competence",
			subPath: "id",
		},
		{
			module: MODULES.PERFIL_PUESTO,
			path: "competencia/category",
			element: <Category />,
			title: "Categorías",
			icon: ManageAccountsIcon  ,
			permissions: [PERMISOS.RH],
			textDivider: "competence",
		},
	]

